<script setup lang="ts">
import { readItems } from '@directus/sdk';
import type { ProfileItem } from '@/components/ProfileGrid.vue';

const { cms, convertAssetUrls } = useCms();
const { data: speakers } = await useAsyncData(
  'speakers',
  async () => {
    const data = await cms.request(
      readItems('cmla_conference_speakers', {
        fields: ['*', 'photo.*', 'avatar.*'],
        limit: 100,
        sort: 'sort',
      }),
    );
    return data.map((x) => {
      return convertAssetUrls(x, ['photo', 'avatar']) as ProfileItem;
    });
  },
  { lazy: true, default: () => [] },
);

const showProfile = ref<ProfileItem>();
</script>

<template>
  <section class="speaker">
    <a id="conference-speaker" />
    <div>
      <div class="container">
        <h1 class="header">Speakers and Chairs</h1>
        <ProfileGrid
          class="speakersGrid"
          :items="speakers"
          @more="(x) => (showProfile = x)"
        />
      </div>
    </div>
  </section>
  <Teleport to="body">
    <ProfileModal
      :show="!!showProfile"
      :item="showProfile"
      @close="showProfile = undefined"
    />
  </Teleport>
</template>

<style scoped lang="scss">
@import '@/assets/css/variables.scss';
@import 'bootstrap/scss/functions.scss';
@import 'bootstrap/scss/variables.scss';
@import 'bootstrap/scss/mixins.scss';

section.speaker {
  padding: 100px 0;
  font-size: 25px;
  font-weight: 600;
  background-color: $primary;
  --bs-body-bg: #{$primary};
  color: white;
  --bs-body-color: white;
}

.header {
  color: white;
  font-size: 60px;
  font-weight: 800;
  margin-bottom: 1em;

  @include media-breakpoint-down(md) {
    font-size: 50px;
  }
}

.speakersGrid {
  justify-content: space-around;

  ::v-deep(.image) {
    border-radius: 50%;
    aspect-ratio: 1;
  }

  ::v-deep(.item) {
    width: 250px;

    @include media-breakpoint-down(sm) {
      width: calc(50% - 24px);
    }
  }
}
</style>
